import { FunctionComponent } from 'preact';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'preact/hooks';
import { css } from '../../styles/styles.utils';
import { anchorOptionsSelector } from '../../store/selectors/anchorOptions.selector';
import { anchorDataSelector } from '../../store/selectors/anchorData.selector';
import { adsDataSelector } from '../../store/selectors/adsData.selector';
import { Icon } from '../icon/icon';
import {
  setUserInteraction,
  updateAnchorDisabledByUser,
} from '../../store/actions/common.actions';

interface CloseIconComponentVariablesProps {
  style: any;
  wrapperStyle?: any;
  addClickableWrapper: boolean;
  id: string;
  icon: SVGElement;
}

export const CloseIcon: FunctionComponent<CloseIconComponentVariablesProps> = props => {
  const {
    style,
    wrapperStyle,
    addClickableWrapper = false,
    id,
    icon,
  } = props;

  const dispatch = useDispatch();
  const closableAd = useSelector(anchorOptionsSelector.closableAd);
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const canClose = useSelector(anchorOptionsSelector.canClose);
  const closeAfter = useSelector(anchorOptionsSelector.closeAfter);
  const anchorStatus = useSelector(anchorDataSelector.anchorStatus);
  const adBreak = useSelector(adsDataSelector.adBreak);

  const [showCloseIconAfterTimeout, setShowCloseIconAfterTimeout] = useState(false);

  const showAdControls = isVastAd && adBreak;
  const showCloseIcon = showCloseIconAfterTimeout && (!showAdControls || closableAd);
  const isAnchored = anchorStatus === 'active';

  useEffect(() => {
    let timer;
    if (isAnchored && canClose) {
      timer = setTimeout(() => {
        setShowCloseIconAfterTimeout(true);
      }, closeAfter * 1000);
    } else {
      setShowCloseIconAfterTimeout(false);
    }
    return (): void => clearTimeout(timer);
  }, [canClose, closeAfter, isAnchored]);

  const onClickClose = useCallback(() => {
    dispatch(setUserInteraction('closeMiniPlayer'));
    dispatch(updateAnchorDisabledByUser(true));
  }, [dispatch]);

  const iconProps = {
    icon,
    id,
    style,
  };

  const CloseIconClickableWrapper: FunctionComponent = () => (
    <div
      style={css(wrapperStyle)}
    >
      <Icon
        {...iconProps}
        onClick={onClickClose}
      />
    </div>
  );

  return (
    showCloseIcon &&
      (addClickableWrapper ?
        <CloseIconClickableWrapper /> :
        (
          <Icon
            {...iconProps}
            onClick={onClickClose}
          />
        )
      )
  );
};
